// extracted by mini-css-extract-plugin
export default {"svg":"SettingsIcon_svg__j+IUD"};